import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import FreelanceBid from "./Jobs/FreelanceBid.component";
import SingleBid from "./SingleBid.component";
import { toast, ToastContainer } from "react-toastify";


export default function BidsList(props) {

  // local state 
  const [bids, setBids] = useState("");
  const [action, setAction] = useState("");

  // redux state 
  const userData = useSelector(state => state.auth.data);
  const token = useSelector(state => state.auth.token);

  const getBidsByPost = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/bids?post_id=${props.postID}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    })
      .then(r => r.json())
      .then(res => {
        if (res.success) {
          // let userbids = res.records.data.filter(item => item.)
          setBids(res.records.data);
        }
      })
  }

  const deleteBid = useCallback(async (del_id) => {

    let txt = "Are You Sure, you want to delete a bid?";
    if(window.confirm(txt) === true){
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/bids/${del_id}`, {
          method: "DELETE",
          headers: {
              "Authorization": `Bearer ${token}`,
          }
      })
      .then(r => r.json())
      .then(response => {
          if(response.success){
              toast.success(response.message);
              setAction("offer deleted");
              props?.setCurrentUserBid(false);
          } else {
              toast.error(response.message);
          }
      })
    }

});

  useEffect(() => {
    getBidsByPost(); 
  }, [action, props.disableOffer]);

  return (
    <>
      <div className="bds-box mt-4">
        <div className="bds-sectiontitle">
          <div className="bds-featureRating">
            <h3>Bids List</h3>
          </div>
        </div>
        {/* users get bids request */}
        {
          userData?.role === 3 ? bids ?
            <div className="bds-reviews">
              <div className="bds-reviews_holder align-items-start">
                {
                  bids?.map((bid, idx) =>
                    <SingleBid
                      key={idx}
                      idx={idx}
                      bid={bid}
                      token={token}
                      setAction={setAction}
                    />
                  )
                }
              </div>
            </div>
            : <p className="text-center text-muted">No Bid Found!</p>
            : ""
        }

        {/* freelancer bids */}
        {
          userData?.role === 2 || userData?.role.id === 2 ? bids ?
            <div className="bds-reviews">
              <div className="bds-reviews_holder align-items-start">
                {
                  bids?.map((bid, idx) => {
                    if(bid.provider_id === userData?.id){ 
                      props.setCurrentUserBid(true);
                      return <FreelanceBid
                        key={idx}
                        idx={idx}
                        bid={bid}
                        token={token}
                        setAction={setAction}
                        deleteBid={deleteBid}
                        posts={props.posts}
                      />
                    }
                  })
                }
              </div>
            </div>
            : ""
            : ""
        }
      </div>
      <ToastContainer />
    </>
  );
}
